export const computeInitials = (name = '') => {
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  const [first, second] = parts;
  return `${first[0] || ''}${second[0] || ''}`.toUpperCase() || '?';
};

export const validatePasswordChange = ({ newPassword, confirmPassword }) => {
  if (!newPassword) {
    return 'Parola nu poate fi goală.';
  }
  if (newPassword !== confirmPassword) {
    return 'Parolele nu se potrivesc.';
  }
  return null;
};
